import angular from 'angular'
import hopscotch from 'hopscotch/dist/js/hopscotch'
import 'hopscotch/dist/css/hopscotch.min.css'
import './hopscotch.scss'

export default angular.module('app.service.hopscotch', [])
  .value('hopscotch', hopscotch)
